/** Same thumb as webinar admin list: 64×48, rounded, object-cover. */
export const ADMIN_LIST_COVER_CLASS =
	"h-[48px] w-[64px] shrink-0 rounded-[8px] object-cover bg-lightCta";

/**
 * @param {boolean} showWhenEmpty — webinar: false; workshop/clip: true (placeholder slot)
 */
export default function AdminListCoverThumb({
	src,
	alt = "",
	showWhenEmpty = false,
}) {
	if (src) {
		return (
			<img
				src={src}
				alt={alt}
				loading="lazy"
				decoding="async"
				className={ADMIN_LIST_COVER_CLASS}
			/>
		);
	}
	if (!showWhenEmpty) {
		return null;
	}
	return (
		<div
			className={`${ADMIN_LIST_COVER_CLASS} flex items-center justify-center object-none font-Vazir-500 text-[10px] text-darkBlue/35`}
			aria-hidden
		>
			بدون کاور
		</div>
	);
}
